/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Onboarding_Session_Hard_Limit_QuestionInputs */

const en_us2_onboarding_session_hard_limit_question = /** @type {(inputs: Onboarding_Session_Hard_Limit_QuestionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Is that a hard limit or a preference?`)
};

const pt_br2_onboarding_session_hard_limit_question = /** @type {(inputs: Onboarding_Session_Hard_Limit_QuestionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Esse tempo é um limite rígido ou uma preferência?`)
};

const es_419_onboarding_session_hard_limit_question = /** @type {(inputs: Onboarding_Session_Hard_Limit_QuestionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Ese tiempo es un límite estricto o una preferencia?`)
};

const pt_pt2_onboarding_session_hard_limit_question = /** @type {(inputs: Onboarding_Session_Hard_Limit_QuestionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Esse tempo é um limite rígido ou uma preferência?`)
};

const fr_fr2_onboarding_session_hard_limit_question = /** @type {(inputs: Onboarding_Session_Hard_Limit_QuestionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`C'est une limite stricte ou une préférence ?`)
};

const de_de2_onboarding_session_hard_limit_question = /** @type {(inputs: Onboarding_Session_Hard_Limit_QuestionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ist das eine feste Grenze oder ein Wunsch?`)
};

const it_it2_onboarding_session_hard_limit_question = /** @type {(inputs: Onboarding_Session_Hard_Limit_QuestionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`È un limite rigido o una preferenza?`)
};

/**
* | output |
* | --- |
* | "Is that a hard limit or a preference?" |
*
* @param {Onboarding_Session_Hard_Limit_QuestionInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const onboarding_session_hard_limit_question = /** @type {((inputs?: Onboarding_Session_Hard_Limit_QuestionInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onboarding_Session_Hard_Limit_QuestionInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_onboarding_session_hard_limit_question(inputs)
	if (locale === "es-419") return es_419_onboarding_session_hard_limit_question(inputs)
	if (locale === "pt-PT") return pt_pt2_onboarding_session_hard_limit_question(inputs)
	if (locale === "fr-FR") return fr_fr2_onboarding_session_hard_limit_question(inputs)
	if (locale === "de-DE") return de_de2_onboarding_session_hard_limit_question(inputs)
	if (locale === "it-IT") return it_it2_onboarding_session_hard_limit_question(inputs)
	return en_us2_onboarding_session_hard_limit_question(inputs)
});
export { onboarding_session_hard_limit_question as "onboarding.session_hard_limit.question" }